<script>
export default {
  name: 'SecondHandSales',
}
</script>

<template>
  <div>SecondHandSales</div>
</template>
